export const tratamientoModal = {
  id: null,
  titulo: '',
  imagen: '',
  contenido: '',
  estado: 1,
}